import { render } from "./ValueDetail.vue?vue&type=template&id=43a6e259"
import script from "./ValueDetail.vue?vue&type=script&lang=js"
export * from "./ValueDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/demonology/demonology/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__